
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSleetShowersPolartwilightColour as ObiLightningLightSleetShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-sleet-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiLightningLightSleetShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-light-sleet-showers-polartwilight-colour',
   elementClass: ObiLightningLightSleetShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 